export default __webpack_public_path__ + "img/restaurants-a34e2b.svg";